module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_an_white-decf788f371c15898207bd5aa13d457e.svg";